import { mailApi } from './mail-api.service';
import { FeedbackConversation } from '../components/pages/Chat/Messages/FeedbackBox/FeedbackBox';

// Type adapter to convert between mindy-app and client API types
const adaptFeedbackConversation = (payload: FeedbackConversation): Record<string, unknown> => ({
    user_email: payload.user_email,
    feedback_date: payload.feedback_date,
    conversation_id: payload.conversation_id,
    previous_messages: payload.previous_messages,
    user_comments: payload.user_comments,
    is_impersonating: payload.is_impersonating,
    original_user_id: payload.original_user_id,
    organization: payload.organization,
    typology: payload.typology,
    environment: payload.environment,
});

/**
 * Mail service wrapper that provides the same interface as the original MailService
 * but uses the new MailApi client underneath.
 */
class MailService {
    private readonly templateId = 'd-c4865d97cc3d49fe97b891b222e1b507'; // Default template ID
    private readonly feedbackEmail: string;

    constructor(private token: string) {
        // Get feedback email from environment
        this.feedbackEmail = process.env['NX_FEEDBACK_MAIL'] || '';

        if (!this.feedbackEmail) {
            throw new Error('NX_FEEDBACK_MAIL environment variable is required but not set');
        }
    }

    /**
     * Send feedback email using the new MailApi
     */
    async sendMail(payload: FeedbackConversation): Promise<void> {
        try {
            const adaptedPayload = adaptFeedbackConversation(payload);
            const response = await mailApi.sendTemplateEmail(this.feedbackEmail, adaptedPayload, this.templateId);
            console.log('Mail sent successfully:', response);
        } catch (error) {
            console.error('Failed to send mail:', error);
            throw error;
        }
    }
}

export default MailService;
